import { render } from "./DestinationForm.vue?vue&type=template&id=d4034a68"
import script from "./DestinationForm.vue?vue&type=script&lang=js"
export * from "./DestinationForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__